import { schoolsResponse } from "./types";

export const schoolsKeys = {
  all: () => ["schools"] as const,
  list: (filters: Partial<schoolsResponse>) =>
    [...schoolsKeys.all(), filters] as const,
};
